module.exports = __webpack_public_path__ + "img/c02_buildingstartechpullsaw_Normal_ua.8928c278.webp";